import { Logger } from '@rchh/lowcode-utils';
export default new Logger({
  level: 'warn',
  bizName: 'renderer'
});